<template>
    <div class="container-box pt-4">
        <div class="info-container">
            <img src="@/assets/logo2.png" class="logo" alt="">
            <h1>
                {{ $t('infoBox.rewardText')[0] }}
                <span class="d-block">
                    {{ $t('infoBox.rewardText')[1] }}
                </span>
            </h1>
            <img class="title-icon" src="@/assets/present.svg" alt="">
            <p>
                {{ $t('infoBox.bringYourFriends') }}
            </p>
            <h2>
                {{ $t('infoBox.stepsText') }}
            </h2>
        </div>
        <div class="step-container">
            <div class="step">
                <div class="line2 d-none" />
                <div class="content">
                    <div class="circle">1</div>
                    <div class="text">
                        {{ $t('infoBox.step1') }}
                    </div>
                </div>
            </div>
            <div class="step">
                <div class="content">
                    <div class="circle">2</div>
                    <div class="text">
                        {{ $t('infoBox.step2') }}
                    </div>
                </div>
            </div>
            <div class="step">
                <div class="content">
                    <div class="circle">3</div>
                    <div class="text">
                        {{ $t('infoBox.step3') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
.container-box {
    width: 100%;
    background: rgba(255, 255, 255, .74);
    backdrop-filter: blur(13px);
    border-radius: 27px;
    box-shadow: 0px 3px 6px #00000029;
    padding-bottom: 50px;
}
.info-container,
.step-container {
    width: 90%;
    margin: 0 auto;
}
.title-icon {
    margin-left: 10rem;
}
.logo {
    width: 20%;
    height: auto;
    margin-top: -1rem;
}
h1 {
    color: #004996;
    word-wrap: break-word;
    font-family: 'RobotoBold';
}
h1 > * {
    font-family: 'RobotoBold';
}
.title-icon {
    display: none;
}
p {
    font-size: .8rem;
    font-family: 'RobotoBold';
    white-space: pre-line;
}
h2 {
    margin-top: 1.5rem;
    font-size: 1rem;
    font-family: 'RobotoBold';
}
.step-container {
    margin-top: 1rem;
    display: flex;
    position: relative;
}
.step {
    flex-grow: 1;
}
.step .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 999;
}
.circle {
    background: #99D24E;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    font-size: 1.4rem;
    text-align: center;
    line-height: 143%;
    font-family: 'RobotoBold';
}
.step .text {
    margin-top: 1.25rem;
    font-weight: bold;
    font-size: .75rem;
    width: 80%;
    text-align: left;
    margin-left: 18%;
}
.line {
    width: 95%;
    background: url('~@/assets/line.svg');
    position: absolute;
    height: 8px;
    top: 12px;
    right: 0.5%;
}
.line2 {
    background: url('~@/assets/line.svg');
    height: 8px;
    width: 100%;
    display: inline-block;
}

.step::before {
    background: url('~@/assets/line.svg');
    background-repeat: repeat-x;
    background-position: 0px 15%;
    content: "";
    width: 33%;
    height: 8px;
    position: absolute;
    top: 12%;
    z-index: 0;
    left: 7px;
}

.step::after {
    background: url('~@/assets/line.svg');
    background-repeat: repeat-x;
    background-position: 0px 15%;
    content: "";
    width: calc(49%);
    height: 8px;
    position: absolute;
    top: 12%;
    z-index: 0;
    left: 50%;
}

.step {
    z-index: 2322;
    overflow: hidden !important;
    position: relative;
    width: 100%;
}

@media screen and (max-width: 396px) {
    h1 {
        font-size: 1.4rem!important;
    }
}
@media screen and (max-width: 500px) {
    .step::before {
        width: 32%;
        top: 11%;
        left: 0px;
    }
    .step::after {
        width: 40%;
        top: 11%;
        left: 70%;
    }
    h1 {
        font-size: 1.85rem;
    }
}
@media screen and (max-width: 530px) {
    .step::before {
        width: 32%;
        top: 11%;
    }
    .step::after {
        width: 40%;
        top: 11%;
        left: 53%;
    }
    h1 {
        font-size: 2rem;
    }
}
@media screen and (min-width: 768px) {
    .logo {
        width: 13%;
    }
    h1 {
        font-size: 2.9rem;
    }
    .title-icon {
        display: block;
        float: right;
        margin-top: -80px;
    }
    p {
        font-size: 1.7rem;
        margin-top: 1rem;
    }
    h2 {
        margin-top: 3rem;
        font-size: 2.2rem;
    }
    .step-container {
        margin-top: 2.5rem;
    }
    .circle {
        width: 68px;
        height: 68px;
        font-size: 3rem;
        text-align: center;
        line-height: 140%;
    }
    .step .text {
        margin-top: 2rem;
        font-size: 1.1rem;
        width: 50%;
        margin-left: 0px;
    }
    .line {
        margin: 0 auto;
        width: 97%;
        background: url('~@/assets/line.svg');
        position: absolute;
        height: 8px;
        top: 26px;
        left: 3%;
        right: 10%;
    }
}
@media screen and (min-width: 1280px) {
    .container-box {
        width: 60%;
    }
}
@media screen and (min-width: 1150px) {
    h1 {
        font-size: 2.5rem;
    }
    .title-icon {
        width: 70px;
    }
    p {
        font-size: 1.6rem;
    }
    h2 {
        margin-top: 3.5rem;
        font-size: 2.4rem;
        text-align: left;
    }
    .step-container {
        margin-top: 3.5rem;
    }
    .circle {
        width: 68px;
        height: 68px;
        font-size: 3rem;
        text-align: center;
        line-height: 140%;
    }
    .step .text {
        width: 50%;
    }
}
@media screen and (min-width: 1484px) {
    p {
        font-size: 1.5rem;
        margin-top: 1.5rem;
    }
}
@media screen and (min-width: 1625px) {
    h1 {
        font-size: 3.3rem;
    }
    .title-icon {
        width: 80px;
    }
    p {
        font-size: 1.7rem;
        margin-top: 1.5rem;
    }
    h2 {
        margin-top: 2.6rem;
        font-size: 2.5rem;
    }
    .step-container {
        margin-top: 2rem;
        margin-bottom: -35px;
    }
    .step .text {
        margin-top: 2rem;
        font-size: 1.25rem;
        width: 50%;
    }
    .circle {
        width: 68px;
        height: 68px;
        font-size: 3rem;
        text-align: center;
        line-height: 140%;
    }
}
@media screen and (min-width: 2399px) {
    .step .text {
        margin-left: 20%!important;
        width: 55%!important;
    }
}

@media screen and (min-width: 1600px) {
    .step .text {
        margin-left: 13%;
        width: 55%;
    }
}

@media screen and (min-height: 789px) {
    .logo {
        width: 9%;
    }
    .step-container {
        margin-bottom: -40px;
    }
    h2 {
        margin-top: 1.5rem;
    }
    .disclaimer {
        margin-bottom: -1.5em;
        margin-top: -.8em;
    }
}

</style>
